export const isValidEmailUser = (username: string): boolean => {
  const userRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]{1,64}$/;
  return userRegex.test(username);
};
